import idb from "@/plugins/indexdb.js";
import PositioningSeatRepo from "@/repositories/products/positioningSeatRepository";

import positioningSeatDefaultForm from "./forms/positioningSeat";

export default {
  namespaced: true,

  state: {
    positioningSeat: positioningSeatDefaultForm
  },

  mutations: {
    SET_POSITIONING_SEAT(state, payload) {
      state.positioningSeat = Object.assign({}, state.positioningSeat, payload);
    },

    // Reset positioning seat object
    RESET_POSITIONING_SEAT(state) {
      state.positioningSeat = positioningSeatDefaultForm;
    }
  },
  actions: {
    /**
     * Get positioning seat product by uuid
     *
     * @param {String} positioning_seat_uuid Lift uuid
     */
    async get({ commit }, positioning_seat_uuid) {
      try {
        const { data } = await PositioningSeatRepo.get(positioning_seat_uuid);
        commit("SET_POSITIONING_SEAT", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new positioning seat
    async createPositioningSeat(context, payload) {
      try {
        const { data } = await PositioningSeatRepo.createPositioningSeat(
          payload
        );
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Local part
     */

    /**
     * Get positioning seat product from IndexedDB
     *
     * @param {String} positioning_seat_uuid Positioning seat uuid
     */
    async getFromLocal({ commit }, positioning_seat_uuid) {
      const positioningSeat = await idb.db.positioning_seat.get(
        positioning_seat_uuid
      );

      // If not found return null
      if (!positioningSeat) return null;

      commit("SET_POSITIONING_SEAT", positioningSeat);

      return positioningSeat;
    },

    resetProduct({ commit }) {
      commit("RESET_POSITIONING_SEAT");
    }
  }
};
